/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBillingOntologyBudgetSync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBillingOntologyBudgetSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBillingOntologyBudgetSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBillingOntologyBudgetSync>): BackgroundJobPayloadForBillingOntologyBudgetSync {
        let obj = Object.assign(new BackgroundJobPayloadForBillingOntologyBudgetSync(), model);
        BackgroundJobPayloadForBillingOntologyBudgetSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBillingOntologyBudgetSync>): BackgroundJobPayloadForBillingOntologyBudgetSync {
        if (!model) return null;
        return BackgroundJobPayloadForBillingOntologyBudgetSync.newInstance(<BackgroundJobPayloadForBillingOntologyBudgetSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBillingOntologyBudgetSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForBillingOntologyBudgetSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBillingOntologyBudgetSync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBillingOntologyBudgetSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account whose budget data is synced to GraphDB
     */
    service_account_id: string;

}
